import React from "react";
import { T } from "services/lang/LanguageService";

interface MissingComponentWarningProps {
  componentId: string | null;
}

export const MissingComponentWarning = ({ componentId }: MissingComponentWarningProps) => {
  const icon = <i className="pi pi-times" style={{ color: "#f6e574", fontSize: "3rem" }} />;
  let errorMsg: string;
  if (componentId != null) {
    errorMsg = T("error.invalid-component-configuration-component-type-does-not-exist", { componentId });
  } else {
    errorMsg = T("error.invalid-component-configuration-component-type-is-missing");
  }

  return (
    <h1 style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      {icon}
      {errorMsg}
      {icon}
    </h1>
  );
};
